<template>
  <div>
    <b-table
      striped
      bordered
      :fields="fields"
      :items="items"
      head-variant="light"
      class="o-list"
      thead-class="o-gradient-header position-sticky"
      sticky-header="70vh"
      no-local-sorting
      @sort-changed="change_sort"
      :sort-by="list_options.sort"
      :sort-desc="list_options.order === 'desc'"
      :tbody-tr-class="rowClass"
    >
      <!-- <template v-slot:cell(_selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template> -->
      <template slot="cell(id)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'id'"
        >
          <default-display :value="item.id"></default-display>
        </o-link-cell>
      </template>

      <template slot="cell(active_end_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'active_end_date'"
        >
          <date-display
            :value="item.active_end_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(active_start_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'active_start_date'"
        >
          <date-display
            :value="item.active_start_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(amount)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'amount'"
        >
          <number-display :value="item.amount" :decimals="2" />
        </o-link-cell>
      </template>
      <template slot="cell(amount_variance)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'amount_variance'"
        >
          <number-display :value="item.amount_variance" :decimals="2" />
        </o-link-cell>
      </template>
      <template slot="cell(authorised_by)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'authorised_by'"
        >
          <default-display :value="item.authorised_by"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(authorised_by_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'authorised_by_date'"
        >
          <date-display
            :value="item.authorised_by_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(awaiting_authorisation)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'awaiting_authorisation'"
        >
          <boolean-display
            :value="item.awaiting_authorisation"
          ></boolean-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(awaiting_authorisation_date)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'awaiting_authorisation_date'"
        >
          <date-display
            :value="item.awaiting_authorisation_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(bill_no)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'bill_no'"
        >
          <p v-for="billing_to in item.billing_to">
            {{ billing_to["bill_no"] }}
          </p>
        </o-link-cell>
      </template>
      <template slot="cell(billed_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'billed_date'"
        >
          <p v-for="billing_to in item.billing_to">
            {{ billing_to["bill_date"] }}
          </p>
        </o-link-cell>
      </template>
      <template slot="cell(billing_to)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'billing_to'"
        >
          <default-display :value="item.billing_to"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(builder)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'builder'"
        >
          <lookup-display
            :list="optionCustomerItemsById"
            :value="item.builder"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(cancelled_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'cancelled_date'"
        >
          <date-display
            :value="item.cancelled_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(code)" slot-scope="{ index, item }">
        <o-link-cell
          target="_blank"
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'code'"
        >
          <default-display :value="item.code"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(completed_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'completed_date'"
        >
          <date-display
            :value="item.completed_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(cost_to)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'cost_to'"
        >
          <p v-for="billing_to in item.billing_to">
            {{ billing_to["sub_contractor_name"] }}
          </p>
        </o-link-cell>
      </template>
      <template slot="cell(created_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'created_date'"
        >
          <date-display
            :value="item.created_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(credit_adj_ref_amount_inc_gst)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'credit_adj_ref_amount_inc_gst'"
        >
          <number-display
            :value="item.credit_adj_ref_amount_inc_gst"
            :decimals="2"
          />
        </o-link-cell>
      </template>
      <template slot="cell(credit_requested)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'credit_requested'"
        >
          <boolean-display :value="item.credit_requested"></boolean-display>
        </o-link-cell>
      </template>
      <template slot="cell(declined)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'declined'"
        >
          <number-display :value="item.declined" :decimals="2" />
        </o-link-cell>
      </template>
      <template slot="cell(description)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'description'"
        >
          <default-display :value="item.description"></default-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(further_info_requested)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'further_info_requested'"
        >
          <boolean-display
            :value="item.further_info_requested"
          ></boolean-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(further_info_requested_date)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'further_info_requested_date'"
        >
          <date-display
            :value="item.further_info_requested_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(invoice_reference)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'invoice_reference'"
        >
          <default-display :value="item.invoice_reference"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(invoices)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'invoices'"
        >
          <default-display :value="item.invoices"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(job)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'job'"
        >
          <default-display :value="item.job"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(modified_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'modified_date'"
        >
          <date-display
            :value="item.modified_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(old_job_no)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'old_job_no'"
        >
          <default-display :value="item.old_job_no"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(purchase_order_number)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'purchase_order_number'"
        >
          <default-display
            :value="item.purchase_order_number"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(repair_files)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'repair_files'"
        >
          <default-display :value="item.repair_files"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(repair_notes)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'repair_notes'"
        >
          <default-display :value="item.repair_notes"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(sales_order_created)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'sales_order_created'"
        >
          <boolean-display :value="item.sales_order_created"></boolean-display>
        </o-link-cell>
      </template>
      <template
        slot="cell(sales_order_created_date)"
        slot-scope="{ index, item }"
      >
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'sales_order_created_date'"
        >
          <date-display
            :value="item.sales_order_created_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(site_address)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_address'"
        >
          <default-display :value="item.site_address"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(suburb)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'suburb'"
        >
          <default-display :value="item.suburb"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(supervisor)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'supervisor'"
        >
          <default-display :value="item.supervisor_name"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(supervisor_name)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'supervisor_name'"
        >
          <default-display :value="item.supervisor_name"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(total_billed)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'total_billed'"
        >
          <p v-for="billing_to in item.billing_to">{{ billing_to["cost"] }}</p>
        </o-link-cell>
      </template>
      <template slot="cell(total_invoiced)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'total_invoiced'"
        >
          <number-display :value="item.total_invoiced" :decimals="2" />
        </o-link-cell>
      </template>
      <template slot="cell(used_materials)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_recharge.edit', params: { id: item.id } }"
          :when="first_column_key === 'used_materials'"
        >
          <default-display :value="item.used_materials"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(audit_trail)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{
            name: 'service_recharge.history',
            params: { rechargeId: item.id, code: item.code },
          }"
        >
          <default-display value="View"></default-display>
        </o-link-cell>

        <!-- <a
          :href="
            'https://shojun3.qa2.ocom.com.au/static/services.html#/service_recharge/history?rechargeId=' +
            item.id
          "
          target="_blank"
          rel="noopener noreferrer"
          >View</a
        > -->
        <!-- <o-link-cell
          :to="{
            name: 'service_repair.history',
            params: { repairId: item.id, code: item.code },
          }"
        >
          <default-display value="View"></default-display>
        </o-link-cell> -->
      </template>
      <template slot="empty">
        <p>
          <emoticon-sad-icon large></emoticon-sad-icon>
        </p>
        No Data Found. Please
        <router-link :to="{ name: 'service_recharge.create' }"
          >create a new item</router-link
        >
      </template>
    </b-table>
    <!-- 
    <o-list-paging
      :limit="list_options.limit"
      :page-options="rows_per_page_items"
      :offset="list_options.offset"
      :total-items="total_items"
      @change-limit="change_limit"
      @change-page="change_page"
    /> -->
  </div>
</template>

<style></style>

<script>
import {
  CreateCodeTableFetchMixin,
  CreateGroupPermissionMixin,
  CreateListPageMixin,
  MultiActionsMixin,
} from "../../../vue-ocom/mixins";
import {
  fieldToTableColumn,
  GetSearchFields,
} from "../../../vue-ocom/schema/schema_utils";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import schema from "../../schema/index";

import OListToolbar from "../../../vue-ocom/components/list/OListToolbar";
import OListPaging from "../../../vue-ocom/components/list/OListPaging";
import DefaultDisplay from "../../../vue-ocom/components/display/DefaultDisplay";
import DateDisplay from "../../../vue-ocom/components/display/DateDisplay";
import NumberDisplay from "../../../vue-ocom/components/display/NumberDisplay";
import BooleanDisplay from "../../../vue-ocom/components/display/BooleanDisplay";
import LookupDisplay from "../../../vue-ocom/components/display/LookupDisplay";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad";
import EmailIcon from "vue-material-design-icons/Email";
import LinkIcon from "vue-material-design-icons/Link";

export default {
  components: {
    EmoticonSadIcon,
    EmailIcon,
    LinkIcon,
    OListPaging,
    OListToolbar,
    DateDisplay,
    DefaultDisplay,
    BooleanDisplay,
    NumberDisplay,
    LookupDisplay,
  },
  mixins: [
    CreateListPageMixin("ServiceRecharge", "service_recharge"),
    MultiActionsMixin,
    CreateGroupPermissionMixin("ServiceRecharge"),
    CreateCodeTableFetchMixin(["Customer", "Supervisor"]),
  ],
  props: {
    jobId: { type: Number, default: null },
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.ServiceRecharge,
        {}
      ) /*Use this.schema instead */,

      search_field_list: GetSearchFields(schema.ServiceRecharge),

      filterRow: true /* Set to False to disable filter row */,
      filter_list: [
        {
          name: "Awaiting Authorisation",
          code: "awaiting_authorisation",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Credit Requested",
          code: "credit_requested",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Sales Order Created",
          code: "sales_order_created",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Sales Order Not Created",
          code: "sales_order_not_created",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Further Info Requested",
          code: "further_info_requested",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Not Billed",
          code: "not_billed",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Cred/Adj Variance",
          code: "has_variance",
          options: { offset: 0, sort: "id" },
        },
        { name: "Billed", code: "billed", options: { offset: 0, sort: "id" } },
        { name: "Active", code: "active", options: { offset: 0, sort: "id" } },
        {
          name: "Cancelled",
          code: "inactive",
          options: { offset: 0, sort: "id" },
        },
      ],

      user_column_selection:
        null /* If user can customise the columns set them here */,
      column_override_params: {
        /* Put any column overrides here key by fieldname */
        id: { label: "No." },
        code: { label: "Ref No." },
        completed_date: { label: "Date Completed" },
        job: { label: "Job No." },
        amount: { label: "Total Amount (inc GST)" },
        total_billed: { label: "Cost To Amount" },
      },
    };
  },
  methods: {
    before_get_all(list_options) {
      /* Overwrite this to update the list_options before the data is changed
       * NOT: use _.cloneDeep(list_options) so the url is not changed
       * */
      var result = _.cloneDeep(list_options);
      result["job"] = this.jobId;
      return result;
    },
    rowClass(item, type) {
      if (item && type === "row") {
        return this.cell_style(null, "", item);
      } else {
        return null;
      }
    },
    cell_style(value, key, item) {
      if (key === "amount" || key === "total_billed") {
        return "text-right";
      }
      return null;
    },
    addTdClass(entries) {
      entries.forEach(function (entry) {
        if (entry) {
          entry["tdClass"] = "cell_style";
        }
      });
    },
  },
  computed: {
    options() {
      return {
        Customer: {
          options: this.optionCustomerItems,
          textField: "name",
          valueField: "id",
        },
        Supervisor: {
          options: this.optionSupervisorItems,
          textField: "name",
          valueField: "id",
        },
        Job: {
          options: this.optionJobItems,
          textField: "description",
          valueField: "id",
        },
      };
    },
    fields() {
      const vm = this;
      const selectedColumns = this.user_column_selection || [
        "code",
        "description",
        "builder",
      ];
      const fields = selectedColumns.map(function (item) {
        return fieldToTableColumn(
          vm.schema,
          item,
          vm.column_override_params[item]
        );
      });

      this.addTdClass(this.filterTableColumns(this.schema, fields));

      return this.addSelectionColums(
        this.filterTableColumns(this.schema, fields)
      );
    },
    first_column_key() {
      if (this.fields) {
        return this.fields[0].key;
      } else {
        return null;
      }
    },
  },
};
</script>
